<template>
  <HorizontalScroller class="BodyContentTable">
    <div v-if="value.title" class="title">{{ value.title }}</div>
    <table class="table">
      <tr v-for="{ _key, cells } in value.rows" :key="_key">
        <component v-for="cell in cells"
          :key="cell._key"
          :is="cell._type === 'header' ? 'th' : 'td'"
          :colspan="cell.colspan"
          :rowspan="cell.rowspan"
        >
          <span v-if="['header', 'basicText'].includes(cell._type)" :class="{ bold: cell.bold, italic: cell.italic }">{{ cell.text }}</span>
          <SanityImage v-else-if="cell._type === 'image'" :asset="cell.asset" :width="cell.width" />
          <div v-if="cell._type === 'blockText'" class="blockText">{{ cell.text }}</div>
        </component>
      </tr>
    </table>
  </HorizontalScroller>
</template>

<script setup>
import HorizontalScroller from '~/vue-components/shared/HorizontalScroller.vue'
const { value } = defineProps({ value: Object })
</script>

<style scoped>

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.table {
  width: 100%;
}

.title + .table {
  margin-top: var(--spacing-0);
}

.table th,
.table td {
  border: thin solid var(--hairline-color);
  padding: 0.3rem var(--spacing-4);
  font-size: var(--font-size-0);
  color: var(--text-color-dark);
}

.table th {
  padding: var(--spacing-3) var(--spacing-4);
  background-color: #f6f6f6;
  text-align: left;
  font-weight: 600;
}

.table td {
  vertical-align: top;
}

.bold {
  font-weight: 600;
}

.italic {
  font-style: italic;
}

.blockText {
  white-space: pre-line;
}
</style>
